export var ConnectionState;
(function (ConnectionState) {
    ConnectionState[ConnectionState["CONNECTING"] = 0] = "CONNECTING";
    ConnectionState[ConnectionState["CONNECTED"] = 1] = "CONNECTED";
    ConnectionState[ConnectionState["RECONNECTING"] = 2] = "RECONNECTING";
    ConnectionState[ConnectionState["DISCONNECTING"] = 3] = "DISCONNECTING";
    ConnectionState[ConnectionState["DISCONNECTED"] = 4] = "DISCONNECTED";
})(ConnectionState || (ConnectionState = {}));
